import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import { uploadFileApi } from '../../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import { convertByteToMB } from '../../../utils/HelperFuncitons';
import Spinwheel from '../../common/Spinwheel';

const AddOrUpdateJobCategory = ({ modalId, formik, loading }) => {

 
  return (
    <div className={`modal fade`} id={modalId} tabIndex="-1" aria-labelledby="blogAddModalLabel" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-centered modal-md" >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="blogAddModalLabel">{formik?.values?.id ? "Update" : "Add"} Category</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={formik?.handleSubmit}>
              
              <div className="mb-3">
                <label htmlFor="categoryName" className="form-label">Category name</label>
                <input type="text" className="form-control" id="categoryName" name="categoryName" placeholder='Enter' value={formik?.values?.categoryName} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                {formik?.touched?.categoryName && formik?.errors?.categoryName ? (<div className='req-error'>{formik?.errors?.categoryName}</div>) : null}
              </div>
              <div className="mb-3">
                <label htmlFor="description" className="form-label">Description</label>
                <textarea className="form-control" id="description" name="description" placeholder='Enter' value={formik?.values?.description} onChange={formik?.handleChange} onBlur={formik?.handleBlur}></textarea>
                {/* <input type="text" className="form-control" id="description" name="description" placeholder='Enter' value={formik?.values?.description} onChange={formik?.handleChange} onBlur={formik?.handleBlur} /> */}
                {formik?.touched?.description && formik?.errors?.description ? (<div className='req-error'>{formik?.errors?.description}</div>) : null}
              </div>
             
              <button type="submit" className="btn btn-primary" disabled={loading}>  {loading ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrUpdateJobCategory;